import { difference } from 'ramda';
import { TGeoValue } from '../../../packages/JsonQuery';

export function getUniqGeo<T extends TGeoValue>(currentGeoValues: T[] | null, newGeoValues: T[]) {
  return difference(newGeoValues, currentGeoValues || []);
}
